'use client';
import { useEffect } from 'react';

export const ScrollToHash = () => {
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) {
      return;
    }

    // ждём, пока элемент реально появится в DOM
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // если элемента ещё нет — попробуем снова чуть позже
        setTimeout(tryScroll, 50);
      }
    };

    tryScroll();
  }, []);

  return null;
};
